import { Directive, forwardRef, Inject, Input } from "@angular/core";
import * as _ from 'lodash';
import { isEmpty } from '../../../common/helper';
import { NavigationService } from "../../../service/navigation.service";
import { CustomTableColumn, DetailsPathTarget } from "../custom-table-column/custom-table-column";

@Directive()
export abstract class CustomTableValueComponent<T extends CustomTableColumn> {

    @Input() column: T;

    @Input() element: any;

    @Input() rowIndex: number;

    constructor(
        @Inject(forwardRef(() => NavigationService)) protected navigationService: NavigationService
    ) { }

    getValue(): any {
        let val = _.get(this.element, this.column.path, this.column.alternativePath ? null : this.column.defaultValue);
        if (isEmpty(val) && this.column.alternativePath) {
            val = _.get(this.element, this.column.alternativePath, this.column.defaultValue);
        }

        /** if value is mapped retrieve the mapped value (like properties dictionary) */
        let mapped = false;
        if (!isEmpty(val) && this.column.valueMap) {
            let mappedValue = this.column.valueMap[val];
            if (!isEmpty(mappedValue)) {
                val = mappedValue;
                mapped = true;
            }
        }
        if (!mapped && !isEmpty(val) && this.column.valueResolver) {
            const resolvedValue = this.column.valueResolver(val, this.element);
            if (!isEmpty(resolvedValue)) {
                val = resolvedValue;
            }
        }
        return val;
    }

    getClass(): string {
        let value = this.getValue();
        let customClasses = [];
        if (this.column.detailsPath && this.column.detailsPathTarget && this.element?.id) {
            customClasses.push('details-path-link');
            customClasses.push('highlight');
        }
        if (typeof value === 'string') {
            customClasses.push('custom-table-cell-' + value.toLowerCase().replace(/\s/g, "_"));
        }
        return customClasses.length ? customClasses.join(' ') : null;
    }

    goToDetailsWithPath($event): void {
        if (this.column.detailsPath && this.column.detailsPathTarget && this.element?.id) {
            $event.stopPropagation();
            const link = [this.getDetailsUrl(this.column.detailsPathTarget), this.element.id, this.column.detailsPath];
            this.navigationService.navigateTo(link);
        }
    }

    protected getDetailsUrl(target: DetailsPathTarget): string {
        switch (target) {
            case DetailsPathTarget.THING:
                return '/dashboard/thing_details';
            case DetailsPathTarget.LOCATION:
                return '/dashboard/location_details';
            case DetailsPathTarget.CUSTOMER:
                return '/dashboard/customer_details';
            case DetailsPathTarget.PARTNER:
                return '/dashboard/partner_details';
        }
    }
}